import React from "react";
import PropTypes from "prop-types";
import { withNamespaces, Trans } from "react-i18next";

import Link from "ati-ui-react/components/Link";

import styles from "./RouteExcluded.scss";
import Country from "../../models/Country";

const RouteExcluded = props => {
  const {
    /** @type {City[]} */
    excludedCities,
    /** @type {Country[]} */
    excludedCountries,
    returnCityToRoute,
    returnCountryToRoute,
    resetExcludedAndCalculateRoute,
    t,
  } = props;

  if (excludedCities.length === 0 && excludedCountries.length === 0) {
    return null;
  }

  const renderExcludedCities = () =>
    excludedCities.map(({ name, id }) => (
      <div className={styles.excludedCity} key={id}>
        <div // eslint-disable-line
          className={styles.excludeIcon}
          title={t("trace-route-excluded-entries-remove-button-text", "Вернуть точку в маршрут")}
          role="button"
          onClick={() => returnCityToRoute(id)}
        />
        <div>{name}</div>
      </div>
    ));

  const renderExcludedCountries = () =>
    excludedCountries.map(({ name, id }) => (
      <div className={styles.excludedCountry} key={id}>
        <div // eslint-disable-line
          className={styles.excludeIcon}
          title={t("trace-route-excluded-entries-remove-button-text", "Вернуть точку в маршрут")}
          role="button"
          onClick={() => returnCountryToRoute(id)}
        />
        <div>{name}</div>
      </div>
    ));

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          <Trans i18nKey="trace-route-excluded-entries-block-title">Исключено из маршрута</Trans>
        </div>
        <div className={styles.link}>
          <Link // eslint-disable-line
            small
            gray
            type="pseudo"
            onClick={resetExcludedAndCalculateRoute}
          >
            <Trans i18nKey="trace-route-excluded-entries-reset-button-text">сбросить</Trans>
          </Link>
        </div>
      </div>
      <div className={styles.excludedCities}>{renderExcludedCities()}</div>
      <div className={styles.excludedCountries}>{renderExcludedCountries()}</div>
    </div>
  );
};

RouteExcluded.propTypes = {
  excludedCities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  excludedCountries: PropTypes.arrayOf(
    PropTypes.shape(Country),
  ).isRequired,
  returnCityToRoute: PropTypes.func.isRequired,
  returnCountryToRoute: PropTypes.func.isRequired,
  resetExcludedAndCalculateRoute: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withNamespaces()(RouteExcluded);
